module.exports = __webpack_public_path__ + "static/media/pl.f6afdb62.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/pl.svg
// module id = 747
// module chunks = 0